import SummarygGraphComponents from './summarygraph.components';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { setSidebarClick } from '../../../redux/sidebar/sidebar.action';
import { useSelector, useDispatch } from 'react-redux';
import ContactSupportContainer from '../../../modules/contactsupport/containers/contactsupport.container';
import ProcessMenuComponent from '../../sidebar/components/process-menu.component';
import { useContext, useEffect, useState } from 'react';
import useHttpApiCall from '../../../services/useHttpApiCall';
import SensorMenuComponent from '../../sidebar/components/sensors-menu.component';
import { context as ProcessContext } from '../../../context/process.context';
import useDashboardRefresh from '../../../hooks/useDashboardRefresh';
import SelectMyDashboardMenu from '../../sidebar/components/myDashboard.menu.component';
import MyDashboardList from '../../../modules/myDashboard/component/myDashboardList.component';
import SelectGraphContainer from '../../../modules/myDashboard/containers/select.graph.container';

export default function HeaderComponents({ setModalShow, modalShow }) {
  const [payload, setPayload] = useState(undefined);
  const [openSelectGraphSlider, setOpenSelectGraphSlider] = useState(false);
  const [editSelectGraphShow, setEditSelectGraphShow] = useState(false);
  const [openDashboardListSlider, setOpenDashboardListSlider] = useState(false);
  const [editPreviewShow, setEditPreviewShow] = useState(false);
  const [isOperator] = useState(localStorage.getItem('is_operator') == 'true');

  const sidebarClick = useSelector((state) => state.sidebarClick.linkClick);
  const set_equipment_filter = useSelector((state) => state.equipmentFilter.set_equipment_filter);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data] = useHttpApiCall(payload);

  const regex = /^\/plant\/[^/]+$/;
  let parentPlantDetails = useContext(ProcessContext).state.sidebarLinks?.layers;
  const plantLayerLink = `/plant/${encodeURIComponent(
    parentPlantDetails?.[0]?.name
  )}?process_type=plant&plant_id=${parentPlantDetails?.[0]?.layer_id}&plant_code=${
    parentPlantDetails?.[0]?.plant_code
  }`;
  const company_layer = localStorage.getItem('company_layer') == 'true';
  const flexibleEquipmentEnabled = localStorage.getItem('flexible_equipment') == 'true';
  const { isRefreshing } = useDashboardRefresh();
  const disableAllMenus = openSelectGraphSlider || openDashboardListSlider || editPreviewShow;

  const onLogoClick = () => {
    dispatch(setSidebarClick(!sidebarClick));
  };

  const handleMyDashboardClick = () => {
    setPayload({
      method: 'GET',
      auth: true,
      url: 'v0/my-dashboard/latest/'
    });
    // setPayload({
    //   method: 'POST',
    //   auth: true,
    //   url: 'v0/my-dashboard/',
    //   data: {
    //     name: 'summary graph',
    //     is_active: true,
    //     graphs: [
    //       {
    //         graph_template: 1,
    //         query_params: 'layer_type=plant&layer_id=21&plant_code=HgabtkVjhF_dELA'
    //       }
    //     ]
    //   }
    // });
  };

  useEffect(() => {
    if (payload?.url === 'v0/my-dashboard/latest/') {
      if (data?.data?.data?.id) {
        const id = data.data.data.id;
        navigate(`/myDashboard/view/${id}`);
      }
    }

    if (payload?.url === 'v0/api/users/logout/' && data?.status == 200) {
      localStorage.clear();
      window.location.reload();
    }
  }, [data]);

  useEffect(() => {
    const isViewDashboardList = location.pathname.includes('viewDashboardList');
    setEditPreviewShow(isViewDashboardList);
  }, [location.pathname]);

  useEffect(() => {
    console.log('redux set equipment filter in header', set_equipment_filter);
  }, [set_equipment_filter]);

  return (
    <div>
      <header className="p-20 daz-header" style={{ userSelect: 'none' }}>
        <div className="daz-header__logo">
          <Link
            to={
              flexibleEquipmentEnabled
                ? company_layer
                  ? '/company'
                  : `${plantLayerLink}`
                : '/home'
            }
            onClick={onLogoClick}>
            <img src="../../../dazoq-logo-black.png" alt="Dazok Logo"></img>
          </Link>
        </div>
        <div>
          {location.pathname == '/home' ||
          location.pathname == '/company' ||
          regex.test(location.pathname) ? (
            <SummarygGraphComponents />
          ) : (
            ''
          )}
        </div>
        <div className="d-flex">
          {/* <Toast
          style={
            isOperator == 'true'
              ? { position: 'absolute', right: '244px', width: '50%' }
              : location.pathname == '/home'
              ? { position: 'absolute', right: '144px' }
              : { position: 'absolute', right: '144px', width: '50%' }
          }>
          <Toast.Body>
            We’re currently experiencing an issue with the visualization of some sensor data. The
            correct data is still available and will soon be displayed correctly. We apologize for
            the inconvenience.
          </Toast.Body>
        </Toast> */}

          {isOperator && (
            <div
              className="daz-header__processwrap"
              style={{
                ...{ marginRight: '0.5rem' },
                ...(disableAllMenus
                  ? { whiteSpace: 'nowrap', pointerEvents: 'none', opacity: 0.4 }
                  : {})
              }}>
              <div className="position-relative daz-header__hoverwrp">
                <a className="d-block text-center" href="#">
                  <i className="medium material-icons notranslate">equalizer</i>
                  {/* <i className="small material-icons notranslate">equalizer</i> */}
                  <span className="txt-14">Add-ons</span>
                </a>
                <SensorMenuComponent sourceHeader />
              </div>
            </div>
          )}

          {flexibleEquipmentEnabled && isOperator && (
            <div
              className="position-relative daz-header__hoverwrp"
              style={{ marginRight: '0.5rem', paddingTop: '10px' }}>
              <NavLink
                to={'/myDashboard'}
                className={({ isActive }) =>
                  'daz-header__iconwrap ' +
                  'd-block text-center' +
                  (isActive ? 'daz-header__iconwrap--active' : '') +
                  (isRefreshing ? ' daz-header__iconwrap--loading' : '') +
                  (disableAllMenus ? ' daz-header__iconwrap--disabled' : '')
                }
                onClick={(e) => {
                  if (disableAllMenus) {
                    e.preventDefault();
                    return;
                  }
                  e.preventDefault();
                  handleMyDashboardClick();
                }}
                style={{
                  whiteSpace: 'nowrap',
                  pointerEvents: disableAllMenus ? 'none' : 'auto',
                  opacity: disableAllMenus ? 0.5 : 1
                }}>
                <i className="medium material-icons notranslate">dashboard</i>
                <span className="txt-14">My Dashboard {isRefreshing ? '...' : ''}</span>
              </NavLink>

              {!disableAllMenus && (
                <SelectMyDashboardMenu
                  oapenSelectGraphSlider={openSelectGraphSlider}
                  editSelectGraphShow={editSelectGraphShow}
                  setOpenSelectGraphSlider={setOpenSelectGraphSlider}
                  setEditSelectGraphShow={setEditSelectGraphShow}
                  setOpenDashboardListSlider={setOpenDashboardListSlider}
                  sourceHeader
                />
              )}
            </div>
          )}

          <div
            className="daz-header__processwrap"
            style={{
              ...(disableAllMenus
                ? { whiteSpace: 'nowrap', pointerEvents: 'none', opacity: 0.4 }
                : {})
            }}>
            <div className="position-relative daz-header__hoverwrp">
              <a className="d-block text-center" href="#">
                <i className="small material-icons notranslate">account_tree</i>
                <span className="txt-14">Processes</span>
              </a>
              <ProcessMenuComponent />
            </div>
          </div>
          <div
            className="daz-header__profilewrap ms-2"
            style={{
              ...(disableAllMenus
                ? { whiteSpace: 'nowrap', pointerEvents: 'none', opacity: 0.4 }
                : {})
            }}>
            <div onClick={() => setModalShow(true)} className="pointer text-center support-icon">
              <i className="small material-icons notranslate">contact_support</i>
              <span className="txt-14">Support</span>
            </div>
          </div>

          <Dropdown
            className="daz-header__dropdown"
            style={{
              ...(disableAllMenus
                ? { whiteSpace: 'nowrap', pointerEvents: 'none', opacity: 0.4 }
                : {})
            }}>
            <Dropdown.Toggle>
              <div className="daz-header__profilewrap ">
                <i className="small material-icons notranslate">face</i>
                <span className="txt-14">Profile</span>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>
                <button
                  className="daz-header__logout text-start"
                  onClick={() => {
                    setPayload({
                      auth: true,
                      url: 'v0/api/users/logout/',
                      method: 'POST'
                    });
                    localStorage.clear();
                    window.location.reload();
                  }}>
                  Logout
                </button>
              </Dropdown.Item>
              <Dropdown.Item className="daz-header__dropdownProfile">
                {' '}
                <button className="text-start " onClick={() => navigate('/profile')}>
                  Profile
                </button>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {<ContactSupportContainer modalShow={modalShow} setModalShow={setModalShow} />}
        </div>
      </header>

      {openSelectGraphSlider && (
        <SelectGraphContainer setOpenSelectGraphSlider={setOpenSelectGraphSlider} />
      )}
      {openDashboardListSlider && (
        <MyDashboardList
          setOpenDashboardListSlider={setOpenDashboardListSlider}
          setOpenSelectGraphSlider={setOpenSelectGraphSlider}
        />
      )}
    </div>
  );
}
